module.exports = __webpack_public_path__ + "static/img/ic-ai-chat.551cafe.png";